import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import * as API from "../../api";
import { InputList } from "../InputList";
import { InputText } from "../InputText";
import { InputTextArea } from "../InputTextArea";
import { InputDate } from "../InputDate";
import { InputNumber } from "../InputNumber";

export const ModuleTareaDatosPostFirma = ({
  data,
  metadata,
  lists,
  values,
  setValues,
  options,
  setOptions,
  label = "Datos PostFirma",
  columns,
  access,
}) => {
  const convertOptions = (options) =>
    options.map((opt) => ({
      value: opt.valor,
      label: opt.etiqueta,
    }));

  const handleChange = (prop, value) => {
    const tmpValues = { ...values };
    tmpValues[prop] = value;
    setValues(tmpValues);
  };

  const handleListChange = (field, value) => {
    const tmpOptions = { ...options };
    const tmpValues = { ...values };
    tmpValues[field.name] = value;
    if (lists[field.list].listasHijas.length === 0) {
      setValues(tmpValues);
    } else
      lists[field.list].listasHijas.forEach((list) => {
        const listaRelacional = {
          nombreLista: field.list,
          idEntidadRelacional: value,
        };
        const data = {
          lista: list,
          listaRelacional,
        };
        API.obtenerLista(data).then((res) => {
          tmpOptions[list] = convertOptions(res.valores);
          setOptions(tmpOptions);
        });
      });
    setValues(tmpValues);
  };

  return (
    <S.Wrapper>
      <S.Header>
        <p>{label}</p>
      </S.Header>
      <S.Content columns={columns}>
        {metadata.map((field) => {
          switch (field.type) {
            case "readonly":
              return (
                <div key={field.name}>
                  <p className="bold">{field.label}</p>
                  <p>{data[field.name]}</p>
                </div>
              );
            case "text":
              return (
                <InputText
                  key={field.name}
                  field={field}
                  value={values[field.name] || ""}
                  handleChange={handleChange}
                  disabled={!access?.Editar}
                />
              );
            case "textarea":
              return (
                <InputTextArea
                  key={field.name}
                  field={field}
                  rows={5}
                  value={values[field.name] || ""}
                  handleChange={handleChange}
                  disabled={!access?.Editar}
                />
              );
            case "list":
              return (
                <InputList
                  key={field.name}
                  field={field}
                  value={values[field.name] || ""}
                  options={options[field.list] || []}
                  handleChange={handleListChange}
                  isClearable={lists[field.list]?.mostrarVacio || false}
                  disabled={
                    !access?.Editar ||
                    (field.name === "motivo" && values.firmaEnHora === "1") ||
                    (field.name === "notaria" && values.provinciaNotaria === "")
                  }
                />
              );
            case "date":
            case "datetime-local":
              return (
                <InputDate
                  key={field.name}
                  field={field}
                  value={values[field.name] || ""}
                  handleChange={handleChange}
                  disabled={!access?.Editar}
                />
              );
            case "number":
              return (
                <InputNumber
                  key={field.name}
                  field={field}
                  value={values[field.name] || ""}
                  handleChange={handleChange}
                  disabled={!access?.Editar}
                />
              );
            default:
              return (
                <div key={field.name}>
                  <p className="bold">{field.label}</p>
                  <p>{data[field.name]}</p>
                </div>
              );
          }
        })}
      </S.Content>
    </S.Wrapper>
  );
};

ModuleTareaDatosPostFirma.propTypes = {
  data: PropTypes.object,
  metadata: PropTypes.array,
  lists: PropTypes.object,
  values: PropTypes.object,
  setValues: PropTypes.func,
  options: PropTypes.object,
  setOptions: PropTypes.func,
  label: PropTypes.string,
  columns: PropTypes.number,
  access: PropTypes.object,
};
